if (!customElements.get('pet-bandana-customizer')) {
  customElements.define('pet-bandana-customizer', class PetBandanaCustomizer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.closest('form');
      this.productInfo = this.closest('product-info');
      this.photo = this.querySelector('input[type="file"]');
      this.name = this.querySelector('input[name="properties[Pet name to print]"]');
      this.phone = this.querySelector('input[name="properties[Phone number to print under front layer]"]');
      this.permission = this.querySelector('input[type="checkbox"]');
      this.filename = this.querySelector('[data-bandana-filename]');
      this.variants = JSON.parse(this.querySelector('[data-bandana-variants]')?.textContent || '[]');
      if (!this.form || !this.productInfo || !this.photo || !this.name || !this.phone || !this.permission) return;

      this.photo.addEventListener('change', () => {
        this.filename.textContent = this.photo.files?.[0]?.name || this.photo.dataset.emptyLabel;
        this.validatePhoto(false);
      });
      this.name.addEventListener('input', () => this.clearError('name', this.name));
      this.phone.addEventListener('input', () => {
        this.clearError('phone', this.phone);
        this.syncPhoneOption();
      });
      this.permission.addEventListener('change', () => this.clearError('permission', this.permission));
      this.productInfo.addEventListener('change', (event) => {
        if (event.target.closest('variant-selects')) this.syncPhoneOption();
      });
      this.observer = new MutationObserver(() => this.hidePhoneOption());
      this.observer.observe(this.productInfo, { childList: true, subtree: true });
      this.hidePhoneOption();

      this.form.addEventListener('submit', (event) => {
        if (!this.validate() || !this.syncPhoneOption()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[aria-invalid="true"]')?.focus();
          return;
        }
        const variant = this.matchingVariant();
        const idInput = this.form.querySelector('input[name="id"]');
        if (variant && idInput) idInput.value = String(variant.id);
      }, true);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    optionGroups() {
      return [...(this.productInfo.querySelector('variant-selects')?.querySelectorAll('fieldset') || [])];
    }

    phoneGroup() {
      return this.optionGroups().find((group) => group.querySelector('legend')?.textContent.trim() === this.dataset.optionName);
    }

    hidePhoneOption() {
      const group = this.phoneGroup();
      if (group) group.style.display = 'none';
    }

    selectedOption(index) {
      return this.optionGroups()[index]?.querySelector('input[type="radio"]:checked')?.value;
    }

    matchingVariant() {
      const phoneOption = this.phone.value.trim() ? this.dataset.optionYes : this.dataset.optionNo;
      const style = this.selectedOption(0);
      const size = this.selectedOption(1);
      return this.variants.find((variant) => variant.style === style && variant.size === size && (variant.phone === phoneOption || (!this.phone.value.trim() && !this.phoneGroup() && !variant.phone)));
    }

    syncPhoneOption() {
      const group = this.phoneGroup();
      const wanted = this.phone.value.trim() ? this.dataset.optionYes : this.dataset.optionNo;
      if (!group && !this.phone.value.trim() && this.matchingVariant()) return true;
      const radio = [...(group?.querySelectorAll('input[type="radio"]') || [])].find((input) => input.value === wanted);
      if (!radio || !this.matchingVariant()) {
        this.setError('variant', this.phone, this.dataset.errorVariant);
        return false;
      }
      this.clearError('variant', this.phone);
      if (!radio.checked) radio.click();
      return true;
    }

    clearError(key, input) {
      const error = this.querySelector(`[data-error-for="${key}"]`);
      if (error) error.textContent = '';
      if (input) input.removeAttribute('aria-invalid');
    }

    setError(key, input, message) {
      const error = this.querySelector(`[data-error-for="${key}"]`);
      if (error) error.textContent = message;
      if (input) input.setAttribute('aria-invalid', 'true');
    }

    validatePhoto(required) {
      this.clearError('photo', this.photo);
      const file = this.photo.files?.[0];
      if (!file) {
        if (required) this.setError('photo', this.photo, this.dataset.errorPhoto);
        return !required;
      }
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        this.setError('photo', this.photo, this.dataset.errorFormat);
        return false;
      }
      if (file.size > 15 * 1024 * 1024) {
        this.setError('photo', this.photo, this.dataset.errorSize);
        return false;
      }
      return true;
    }

    validate() {
      let valid = this.validatePhoto(true);
      this.clearError('name', this.name);
      this.clearError('phone', this.phone);
      this.clearError('permission', this.permission);
      this.name.value = this.name.value.trim();
      this.phone.value = this.phone.value.trim();

      if (!this.name.value) {
        this.setError('name', this.name, this.dataset.errorName);
        valid = false;
      }
      if (this.phone.value) {
        const digits = this.phone.value.replace(/\D/g, '');
        if (!/^[+()0-9 .-]{5,25}$/.test(this.phone.value) || digits.length < 5 || digits.length > 20) {
          this.setError('phone', this.phone, this.dataset.errorPhone);
          valid = false;
        }
      }
      if (!this.permission.checked) {
        this.setError('permission', this.permission, this.dataset.errorPermission);
        valid = false;
      }
      return valid;
    }
  });
}

